module.exports = __webpack_public_path__ + "static/media/calendar.c187c397.svg";